import type { BookAnswer, MemoDraft } from '@cyberscore/contracts';
import { useMutation } from '@tanstack/react-query';
import { api, ApiError } from '../../lib/api';

/** The underwriter assistant (task 74): drafts asked for, never saved, so nothing is cached. */
export const useAskBook = () =>
  useMutation({ mutationFn: (question: string) => api<BookAnswer>('POST', '/assistant/book', { question }) });

export const useDraftMemo = (id: string) =>
  useMutation({ mutationFn: () => api<MemoDraft>('POST', `/assessments/${id}/memo`) });

export const assistantError = (e: unknown) =>
  e instanceof ApiError
    ? e.status === 429
      ? 'This month’s AI budget is used up, or you asked too often. Try again later.'
      : (e.issues[0]?.message ?? e.message)
    : 'The assistant could not answer. Try again.';
